import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { series } from 'reducers/series/selectors';
import { inCartSelected, serieModelIds } from 'reducers/inCartSeries/selectors';
import { inCartBodyStyleIdsBySeries } from 'reducers/inCartModels/selectors';
import { bodyStyleIds } from 'reducers/bodyStyles/selectors';
import { mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  series,
  inCartBodyStyleIdsBySeries,
  bodyStyleIds,
  inCartSelected,
  mini,
  serieModelIds,
});

export const relevantBodyStyleIds = ({
  inCartBodyStyleIdsBySeries,
  bodyStyleIds,
}) => {
  return bodyStyleIds.filter(bodyStyleId =>
    inCartBodyStyleIdsBySeries.includes(bodyStyleId),
  );
};

export const subsectionIds = ({ mini, relevantBodyStyleIds, serieModelIds }) =>
  mini ? serieModelIds : relevantBodyStyleIds;

export const seriesLabel = ({ name, seriesString, mini }) =>
  mini ? `${name}` : `${name} ${seriesString}`;

export const totalSelectedStat = ({ totalSelectedString, inCartSelected }) =>
  `${totalSelectedString}: ${inCartSelected}`;

export default compose(
  connect(mapStateToProps),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['seriesString', 'totalSelectedString'],
  }),
  flattenProp('series'),
  addProps({
    relevantBodyStyleIds,
    seriesLabel,
    totalSelectedStat,
  }),
  addProps({ subsectionIds }),
);
